export const FloatLabel = (() => {
	const handleFocus = (e) => {
		const target = e.target;
		target.parentNode.parentNode.classList.add("label-is-floating");
	};

	const handleBlur = (e) => {
		const target = e.target;
		if (!target.value) {
			target.parentNode.parentNode.classList.remove("label-is-floating");
		}
	};

	const bindEvents = (element) => {
		const floatField = element.querySelector("input, textarea, select");

		floatField.addEventListener("focus", handleFocus);
		floatField.addEventListener("blur", handleBlur);
	};

	const init = () => {
		const floatContainers = document.querySelectorAll(".field_sublabel_below, .has-floating-label");

		floatContainers.forEach((element) => {
			if (element.querySelector("input, textarea, select").value) {
				element.classList.add("label-is-floating");
			}

			bindEvents(element);
		});
	};

	return {
		init: init,
	};
})();
